import { axios } from './config';

export function getCode(params) {
  return axios.post('/verificationCode/sendCode', params, true)
}

export function changePassWord(params) {
  return axios.post('/verificationCode/changePassword', params, true)
}
